import {
    GET_COLUMN_PERMISSION_ERROR,
    GET_COLUMN_PERMISSION_REQUEST,
    GET_COLUMN_PERMISSION_SUCCESS, UPDATE_COLUMN_PERMISSION_ERROR,
    UPDATE_COLUMN_PERMISSION_REQUEST, UPDATE_COLUMN_PERMISSION_SUCCESS
} from "../types";
import {updateItemWithCustomColumnIdInArray} from "../../utils/FilterUtils/FilterUtils";

// Always an array: the Gantt column build runs `.find` on it during render,
// and the request failing (or answering with an error body) must not turn
// into a render-time TypeError on every page that shows custom columns.
const initialState = {
    columnPermissions: [],
    isFetching: false,
    error: "",
};

export default function (state = initialState, {type, payload}) {
    switch (type) {
        case GET_COLUMN_PERMISSION_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case GET_COLUMN_PERMISSION_SUCCESS:
            return {
                ...state,
                isFetching: false,
                error: "",
                columnPermissions: Array.isArray(payload) ? payload : [],
            };
        case GET_COLUMN_PERMISSION_ERROR:
            return {
                ...state,
                isFetching: false,
                error: payload,
            };
        case UPDATE_COLUMN_PERMISSION_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case UPDATE_COLUMN_PERMISSION_SUCCESS:
            return {
                ...state,
                isFetching: false,
                error: "",
                columnPermissions: updateItemWithCustomColumnIdInArray(state.columnPermissions, payload),
            };
        case UPDATE_COLUMN_PERMISSION_ERROR:
            return {
                ...state,
                isFetching: false,
                error: payload,
            };
        default:
            return state;
    }
}